/* Typing animation for the search fields' placeholder (the header's inline
   search and the search modal). Reads the phrases from data-typing-phrases
   (JSON array) on each input, types one out, holds, deletes it, then moves to
   the next. The animation pauses while the field has text, and is skipped
   entirely for reduced motion, in which case the static placeholder stays. */
(function () {
	const TYPE_MS = 100;
	const DELETE_MS = 60;
	const HOLD_MS = 2000;
	const GAP_MS = 60;
	const IDLE_MS = 500;

	if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	function animate(input) {
		let phrases;
		try {
			phrases = JSON.parse(input.dataset.typingPhrases);
		} catch (e) {
			return;
		}
		if (!Array.isArray(phrases) || !phrases.length) return;

		input.setAttribute('data-typing', '');
		let phraseIndex = 0;
		let charCount = 0;
		let deleting = false;

		// A single space keeps :placeholder-shown true while the text is empty.
		const show = (text) => {
			input.placeholder = text || ' ';
		};

		function tick() {
			if (!input.isConnected) return;
			// Don't animate while the user has typed something or the field is hidden.
			if (input.value !== '' || input.offsetParent === null) {
				setTimeout(tick, IDLE_MS);
				return;
			}
			const phrase = phrases[phraseIndex];
			let delay;
			if (!deleting) {
				charCount += 1;
				show(phrase.slice(0, charCount));
				if (charCount >= phrase.length) {
					deleting = true;
					delay = HOLD_MS;
				} else {
					delay = TYPE_MS;
				}
			} else {
				charCount -= 1;
				show(phrase.slice(0, charCount));
				if (charCount <= 0) {
					deleting = false;
					phraseIndex = (phraseIndex + 1) % phrases.length;
					delay = GAP_MS;
				} else {
					delay = DELETE_MS;
				}
			}
			setTimeout(tick, delay);
		}

		// When the field is cleared, start the current phrase over.
		input.addEventListener('input', () => {
			if (input.value === '') {
				charCount = 0;
				deleting = false;
				show('');
			}
		});

		show('');
		setTimeout(tick, GAP_MS);
	}

	function init() {
		document.querySelectorAll('input[data-typing-phrases]').forEach((input) => {
			if (input.dataset.typingInit) return;
			input.dataset.typingInit = '1';
			animate(input);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	document.addEventListener('shopify:section:load', init);
})();
